import { Component, OnInit, HostListener, Renderer2, Inject } from '@angular/core';
import { CognitoService } from 'src/service/cognito.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
const HASHKEY = "B@j@j@123%&~SSO*7&%";
import { jwtDecode } from 'jwt-decode';
declare var $: any;

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})
export class SignInComponent implements OnInit {
  isSignIn: boolean = true;
  confirmationCode: string = '';
  isSignUpComplete: boolean = false;
  password: string = '';
  password2: string = '';
  email: string = '';
  name: string = '';
  username: string = '';
  username2: string = '';
  clientId: any = '';
  isSignedIn: boolean = false;
  signedInUserEmail: any = '';
  isPasswordReset: boolean = false;
  isResetCodeSent: boolean = false;
  newPassword: string = '';
  isresetpassword: boolean = false;
  signInErrorMessage: any = '';
  UserSignIn: boolean = false;
  savedUserEmail: any = '';
  userSession: any = '';
  token: any = '';
  loader: boolean = false;
  mobile: string = '';
  otp: any = '';
  signmobile: boolean = false;
  signotp: boolean = false;
  resendotp: boolean = false;
  expiredpop: boolean = false;
  otpexpiredpop: boolean = false;
  passwordResetSuccess: boolean = false;
  activeTab = 'sign-in';
  userPoolId: string = environment.userPoolId;
  isRmCodeActive: boolean = false;
  rmresult: any = '';
  b2b_insurance = environment.b2b_insurance;
  retirment_clientid = environment.retirment_clientid;
  surveypro_clientid = environment.surveypro_clientid;
  bqdashboard_clientid = environment.bqdashboard_clientid;
  b2b_india_bonds_clientid = environment.b2b_india_bonds_clientid;
  DatacloudWM_clientid = environment.DatacloudWM_clientid;
  fpb2b_clientid = environment.fpb2b_clientid
  digitalrm_clientid = environment.digitalrm_clientid
  post_retirement_clientid = environment.post_retirement_clientid;
  isUserInactive: boolean = false;
  isresetpasswordb2b: boolean = false;
  isconfirmpasswordb2b: boolean = false;
  showCreateAccountLink = false;
  hideGoogleLogin = false;

  constructor(private cognitoService: CognitoService, private router: Router, private route: ActivatedRoute, private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document) { }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  async ngOnInit() {
   this.setCanonicalURL();
    this.route.queryParams.subscribe((params) => {
      this.clientId = params['clientId'] || null;
      this.hideGoogleLogin = this.clientId === environment.b2b_insurance;
      const action = params['action'] || null;
      if (action === 'logout') {
        this.router.navigate(['/sign-in'], { queryParams: { clientId: this.clientId } });
        localStorage.clear();
      }
      else if (action === 'signup') {
        localStorage.clear();
        this.router.navigate(['/sign-up'], { queryParams: { clientId: this.clientId } });
      }
      this.cognitoService.configureUserPoolBasedOnClientId(this.clientId);
      if (this.clientId) {
        this.cognitoService.configureOAuth(this.clientId);
      }
    });

    try {
      let ssoauthlogintoken: string | null;
      const LastAuthUserName = `CognitoIdentityServiceProvider.${this.clientId}.LastAuthUser`;
      const LastAuthUserValue = localStorage.getItem(LastAuthUserName);

      const isB2BClient = [this.b2b_insurance, this.retirment_clientid, this.surveypro_clientid, this.bqdashboard_clientid, this.post_retirement_clientid, this.b2b_india_bonds_clientid, this.DatacloudWM_clientid, this.fpb2b_clientid,this.digitalrm_clientid].includes(this.clientId);

      if (isB2BClient) {
        this.activeTab = 'rm-code';
        this.isRmCodeActive = true;
        ssoauthlogintoken = localStorage.getItem('ssobauthToekn');
      } else {
        this.isRmCodeActive = this.activeTab === 'rm-code';
        ssoauthlogintoken = localStorage.getItem('ssocauthToekn');
      }

      if (ssoauthlogintoken) {
        const obj = { token: ssoauthlogintoken };
        const tokenApiCall = isB2BClient ? this.cognitoService.b2b_TokenApi(obj) : this.cognitoService.TokenApi(obj);

        tokenApiCall.subscribe(async (data: any) => {
          const apiToken = data.body;
          if (data.statusCode === 401 || data.statusCode === 500) {
            this.handleSignOut();
            return;
          }
          if (isB2BClient) {
            localStorage.setItem('ssobauthToekn', apiToken);
          } else {
            localStorage.setItem('ssocauthToekn', apiToken);
          }
          const decodedPayload = JSON.parse(atob(apiToken.split('.')[1]));
          this.savedUserEmail = decodedPayload.email && decodedPayload.email.endsWith('_it@bajajcapital.com')
            ? decodedPayload.name
            : decodedPayload.email;

          if (this.savedUserEmail || this.userSession || LastAuthUserValue) {
            this.UserSignIn = true;
            this.signedInUserEmail = this.savedUserEmail;
          } else {
            this.UserSignIn = false;
          }
        });
      } else {
        this.UserSignIn = false;
      }
    } catch (error) {
      console.error('Error fetching auth session:', error);
      this.UserSignIn = false;
    }
    this.email = '';
  }

setCanonicalURL() {
  const url = window.location.origin; 

  let link: HTMLLinkElement =
    document.querySelector("link[rel='canonical']") || document.createElement('link');

  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', url + '/');
  document.head.appendChild(link);
}

  showError(message: string, timeout: number = 5000) {
    this.signInErrorMessage = message;
    setTimeout(() => { this.signInErrorMessage = ''; }, timeout);
    this.loader = false;
  }

  // Helper: Parse API response body
  parseResponseBody(body: any): any {
    try {
      return typeof body === 'string' ? JSON.parse(body) : body;
    } catch (err) {
      console.error('Failed to parse response body', err);
      return null;
    }
  }






  // new lambda b2c
  async onSignIn() {
    if (!this.username) return this.showError('Please enter a valid Mobile/Email');
    if (!this.password) return this.showError('Password is required to sign in');

    let signInUsername = this.username.trim();
    const isMobile = /^[0-9]{10}$/.test(signInUsername);
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(signInUsername);
    const numbersOnly = /^[0-9]+$/.test(signInUsername);

    if (isMobile) {
      signInUsername = '+91' + signInUsername;
    } else if (numbersOnly && signInUsername.length !== 10) {
      return this.showError('Mobile number must be exactly 10 digits');
    } else if (!isEmail) {
      return this.showError('Please enter a valid email');
    }

    this.loader = true;
    // this.cognitoService.getIpAddress().catch(() => null);
    // 🔹 Prepare payload
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify({ userid: signInUsername }), HASHKEY).toString();

    const encryptedPayload = { userid: ciphertext, AppType: '1' };

    this.cognitoService.b2CunifiedUserCheck(encryptedPayload).subscribe(
      (res: any) => {
        console.log('res', res)
        const parsed = res?.body || res;

        // 🔹 Always show API error message
        if (!parsed.success) {
          this.loader = false;
          let errorMsg = parsed.error || parsed.message;
          return this.showError(errorMsg);
        }
        // 🔹 Reset condition
        if (parsed.user_status === 0 && parsed.message === 'Reset required') {
          this.expiredpop = true;
          this.loader = false;
          return;
        }

        // 🔹 Proceed with Cognito login
        this.cognitoService.handleSignIn({
          username: signInUsername,
          password: this.password,
        }).then(async () => {
          await this.logUserEvent(signInUsername, 'signIn', 'pass', '', 1);
          this.loader = false;
          this.redirectUser('b2c');
        }).catch(async (error: any) => {
          await this.logUserEvent(signInUsername, 'signIn', 'fail', 'invalid username & password', 1);
          this.loader = false;

          if (error.message.includes('User pool client') && error.message.includes('does not exist')) {
            this.showError('User pool client does not exist.');
          } else if (error.message.includes('There is already a signed in user')) {
            this.redirectUser('b2c');
          } else if (error.message.includes('Incorrect username or password')) {
            this.showError('Incorrect username or password.');
          } else if (error.message.includes('Auth UserPool not configured')) {
            this.showError('Auth UserPool not configured.');
          } else {
            this.showError(error.message || 'Something went wrong.');
          }
        });
      },
      (err) => {
        this.loader = false;
        this.showError(err?.error?.message || 'Something went wrong. Please try again.');
      }
    );
  }


  async b2bonSignIn() {
    if (!this.validateUsername2()) return;

    if (!this.password2) {
      this.showError('Password is required to sign in');
      return;
    }

    let signInUsername = this.username2.trim();
    const isMobile = /^[0-9]{10}$/.test(signInUsername);
    const isRmCode = /^[0-9]{5,6}$/.test(signInUsername);

    if (isMobile) {
      signInUsername = '+91' + signInUsername;
    }

    this.loader = true;

    // new lambda
    const userCheckObj = { user_name: signInUsername };
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(userCheckObj), HASHKEY).toString();
    const encryptedPayload = { data: ciphertext, AppType: '2' };
    console.log('%%', encryptedPayload)

    this.cognitoService.unifiedUserCheck(encryptedPayload).subscribe(
      async (response: any) => {
        const parsed = this.parseResponseBody(response.body);

        const userData = parsed.data || {};
        const userStatus = userData.activeuser;
        const passReset = parsed.user_status;
        const loginMessage = parsed.login_message;

        if (parsed?.message === 'User does not exist') {
          this.loader = false;
          return this.showError('Invalid login credentials. Please try again.');
        }

        // Check for inactive users
        if (userStatus === 'inactive') {
          this.isUserInactive = true;
          this.loader = false;
          return;
        }

        // Handle login block due to too many attempts
        if (parsed.message?.includes('Too many attempts')) {
          this.loader = false;
          return this.showError(parsed?.message || 'Login attempt failed. Please try again.');
        }

        // Override mobile if rm_code was used and mobile is returned
        if (isRmCode && userData.mobile) {
          signInUsername = userData.mobile.startsWith('+91') ? userData.mobile : '+91' + userData.mobile;
        }

        // Handle password reset flag
        if (passReset === 0) {
          this.expiredpop = true;
          this.loader = false;
          return;
        }

        // Proceed with Cognito login
        this.cognitoService.handleSignIn({
          username: signInUsername,
          password: this.password2,
        }).then(async () => {
          await this.logUserEvent(signInUsername, 'signIn', 'pass', '', 2);
          this.loader = false;
          this.redirectUser('b2b');
        }).catch(async (error: any) => {
          await this.logUserEvent(signInUsername, 'signIn', 'fail', 'invalid username & password', 2);
          this.loader = false;
          if (error.message.includes('User pool client') && error.message.includes('does not exist')) {
            this.showError('User pool client does not exist.');
          } else if (error.message.includes('There is already a signed in user')) {
            this.showError('');
            this.redirectUser('b2b');
          } else if (error.message.includes('Incorrect username or password')) {
            this.showError('Invalid login credentials. Please try again.');
          } else if (error.message.includes('Auth UserPool not configured')) {
            this.showError('Auth UserPool not configured.');
          } else {
            this.showError('Something went wrong. Please try again.');
          }
        });

      },
      () => {
        this.loader = false;
        this.showError('Network error. Please try again.', 3000);
      }
    );
  }

  // redirectUser(type: 'b2c' | 'b2b') {
  //   let redirectUrl = '';
  //   this.token =
  //     type === 'b2c' ? localStorage.getItem('ssocauthToekn') : localStorage.getItem('ssobauthToekn');

  //   const redirectNow = () => {
      
  //     if (this.clientId === environment.nps_subdomain_clientid) {
  //       redirectUrl = `${environment.redirectUrlnps_subdomain}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.mf_clientid) {
  //       redirectUrl = `${environment.redirectUrlmf}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.insurance_clientid) {
  //       redirectUrl = `${environment.redirectUrlinsurance}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.b2b_insurance) {
  //       redirectUrl = `${environment.redirectUrlB2BINS}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.retirment_clientid) {
  //       redirectUrl = `${environment.retirment_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.surveypro_clientid) {
  //       redirectUrl = `${environment.surveypro_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.bqdashboard_clientid) {
  //       redirectUrl = `${environment.bqdashboard_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.b2b_india_bonds_clientid) {
  //       redirectUrl = `${environment.b2b_indiabonds_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.post_retirement_clientid) {
  //       redirectUrl = `${environment.post_retirement_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.b2c_insurance_clientid) {
  //       redirectUrl = `${environment.redirectionurl_b2c_insurance}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.b2c_india_bonds) {
  //       redirectUrl = `${environment.redirectionurl_b2c_indiabonds}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.unifieddashboard) {
  //       redirectUrl = `${environment.unifieddashboard_redirection}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.DatacloudWM_clientid) {
  //       redirectUrl = `${environment.DatacloudWM_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.fpb2b_clientid) {
  //       redirectUrl = `${environment.fp_url}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.fpb2c_clientid) {
  //       redirectUrl = `${environment.fpc_redirection}?ssotoken=${this.token}`;
  //     } else if (this.clientId === environment.bcml_insurance) {
  //       redirectUrl = `${environment.bcml_insurance_redirection}?ssotoken=${this.token}`;
  //     }
  //     if (!redirectUrl || !this.token) {
  //       console.warn('Invalid redirectUrl or token. Clearing session.');
  //       localStorage.clear();
  //       location.reload();
  //       return;
  //     }

  //     window.location.href = redirectUrl;
  //   };

  //   if (this.token) {
  //     redirectNow();
  //     return;
  //   }

  //   // ✅ Get Cognito token & call API
  //   const lastAuthUserName = `CognitoIdentityServiceProvider.${this.clientId}.LastAuthUser`;
  //   const lastAuthUserValue = localStorage.getItem(lastAuthUserName);
  //   const lastIdTokenName = `CognitoIdentityServiceProvider.${this.clientId}.${lastAuthUserValue}.idToken`;
  //   const lastAuthUser = localStorage.getItem(lastIdTokenName);

  //   if (!lastAuthUser) {
  //     console.warn('No valid token found. Clearing session.');
  //     localStorage.clear();
  //     location.reload();
  //     return;
  //   }
  //   console.log('LastAuthUser:', lastAuthUser);
  //   const obj = { token: lastAuthUser };
  //   const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), HASHKEY).toString();
  //   this.cognitoService.getSsoToken({ data: ciphertext }).subscribe((res: any) => {
  //     console.log('SSO Token Response:', res);
  //     this.token = res.token;
  //       if (type === 'b2c') {
  //         localStorage.setItem('ssocauthToekn', this.token);
  //       } else {
  //         localStorage.setItem('ssobauthToekn', this.token);
  //       }
  //       // redirectNow();
  //     });
  // }



redirectUser(type: 'b2c' | 'b2b') {
  let redirectUrl = '';

  this.token =
    type === 'b2c'
      ? localStorage.getItem('ssocauthToekn')
      : localStorage.getItem('ssobauthToekn');

  const getUserTypeFromToken = (token: string): string => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload['custom:userType'] || '';
    } catch (error) {
      console.error('Error decoding token:', error);
      return '';
    }
  };

  const redirectNow = () => {

    // ✅ Get Cognito idToken
    const lastAuthUserName = `CognitoIdentityServiceProvider.${this.clientId}.LastAuthUser`;
    const lastAuthUserValue = localStorage.getItem(lastAuthUserName);

    const lastIdTokenName = `CognitoIdentityServiceProvider.${this.clientId}.${lastAuthUserValue}.idToken`;

    const idToken = localStorage.getItem(lastIdTokenName);

    const userType = idToken
      ? getUserTypeFromToken(idToken).toUpperCase()
      : '';

    console.log('UserType:', userType);

    // ✅ Restrict POS/PTE/AGENT users for other B2B apps
    const restrictedUsers = ['POS', 'PTE', 'AGENT'];

    const isRestrictedUser = restrictedUsers.includes(userType);

    const isB2BInsuranceClient =
      this.clientId === environment.b2b_insurance;

    // ✅ POS/PTE/AGENT can login only in B2B Insurance
    if (isRestrictedUser && !isB2BInsuranceClient) {

      this.showError(
        'You are not authorized to access this application.'
      );

      setTimeout(() => {
        localStorage.clear();
      }, 3000);

      return;
    }

    // ✅ Redirect URLs
    if (this.clientId === environment.nps_subdomain_clientid) {
      redirectUrl = `${environment.redirectUrlnps_subdomain}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.mf_clientid) {
      redirectUrl = `${environment.redirectUrlmf}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.insurance_clientid) {
      redirectUrl = `${environment.redirectUrlinsurance}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.b2b_insurance) {
      redirectUrl = `${environment.redirectUrlB2BINS}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.retirment_clientid) {
      redirectUrl = `${environment.retirment_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.surveypro_clientid) {
      redirectUrl = `${environment.surveypro_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.bqdashboard_clientid) {
      redirectUrl = `${environment.bqdashboard_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.b2b_india_bonds_clientid) {
      redirectUrl = `${environment.b2b_indiabonds_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.post_retirement_clientid) {
      redirectUrl = `${environment.post_retirement_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.b2c_insurance_clientid) {
      redirectUrl = `${environment.redirectionurl_b2c_insurance}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.b2c_india_bonds) {
      redirectUrl = `${environment.redirectionurl_b2c_indiabonds}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.unifieddashboard) {
      redirectUrl = `${environment.unifieddashboard_redirection}?ssotoken=${this.token}`;
    } else if (this.clientId === environment.unifieddashboardcopy) {
      redirectUrl = `${environment.unifieddashboardcopy_redirection}?ssotoken=${this.token}`;
    } 
   else if (this.clientId === environment.DatacloudWM_clientid) {
      redirectUrl = `${environment.DatacloudWM_url}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.fpb2b_clientid) {
      redirectUrl = `${environment.fp_url}?ssotoken=${this.token}`;
    }else if (this.clientId === environment.digitalrm_clientid) {
      redirectUrl = `${environment.digitalrm_url}?ssotoken=${this.token}`;
    }
     else if (this.clientId === environment.fpb2c_clientid) {
      redirectUrl = `${environment.fpc_redirection}?ssotoken=${this.token}`;

    } else if (this.clientId === environment.bcml_insurance) {
      redirectUrl = `${environment.bcml_insurance_redirection}?ssotoken=${this.token}`;
    }

    // ✅ Final validation
    if (!redirectUrl || !this.token) {
      console.warn('Invalid redirectUrl or token. Clearing session.');

      localStorage.clear();
      location.reload();

      return;
    }

    window.location.href = redirectUrl;
  };

  // ✅ Existing token flow
  if (this.token) {
    redirectNow();
    return;
  }

  // ✅ Get Cognito token & call API
  const lastAuthUserName = `CognitoIdentityServiceProvider.${this.clientId}.LastAuthUser`;

  const lastAuthUserValue = localStorage.getItem(lastAuthUserName);

  const lastIdTokenName = `CognitoIdentityServiceProvider.${this.clientId}.${lastAuthUserValue}.idToken`;

  const lastAuthUser = localStorage.getItem(lastIdTokenName);

  if (!lastAuthUser) {
    console.warn('No valid token found. Clearing session.');

    localStorage.clear();
    location.reload();

    return;
  }

  console.log('LastAuthUser:', lastAuthUser);

  const obj = { token: lastAuthUser };

  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(obj),
    HASHKEY
  ).toString();

  this.cognitoService
    .getSsoToken({ data: ciphertext })
    .subscribe((res: any) => {

      console.log('SSO Token Response:', res);

      this.token = res.token;

      if (type === 'b2c') {
        localStorage.setItem('ssocauthToekn', this.token);
      } else {
        localStorage.setItem('ssobauthToekn', this.token);
      }

      redirectNow();
    });
}


  PasswordReset() {
    this.expiredpop = false;
    this.otpexpiredpop = false;
    this.isSignIn = false;
    this.isresetpassword = true;
    this.signInErrorMessage = '';
    this.email = '';
    this.signmobile = false;
    if (this.clientId === this.b2b_insurance || this.clientId === this.retirment_clientid || this.clientId === this.surveypro_clientid || this.clientId === this.bqdashboard_clientid || this.clientId === this.post_retirement_clientid || this.clientId === this.b2b_india_bonds_clientid || this.clientId === this.DatacloudWM_clientid || this.clientId === this.fpb2b_clientid || this.clientId === this.digitalrm_clientid) {
      this.isresetpassword = false;
      this.isresetpasswordb2b = true;
    } else {
      this.isresetpassword = true;
      this.isresetpasswordb2b = false;
    }
  }



  async onSendResetCode() {
    this.confirmationCode = '';
    this.newPassword = '';
    this.showCreateAccountLink = false;

    const email = this.email?.trim();
    if (!email) {
      this.showError('Email is required to reset password');
      return;
    }

    const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    if (!isEmailValid) {
      this.showError('Please enter a valid email address');
      return;
    }

    this.loader = true;

    // Step 1: Check if email exists with encryption
    const emailObj = { email };
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(emailObj), HASHKEY).toString();

    this.cognitoService.b2ccheckemailexits({ data: ciphertext }).subscribe(
      async (res: any) => {
        const body = typeof res?.body === 'string' ? JSON.parse(res.body) : res?.body || {};

        if (!body.exists) {
          this.loader = false;
          this.showCreateAccountLink = true;
          this.showError('No B2C account found with this email. Please verify.');
          return;
        }

        // Step 2: Handle reset password
        try {
          await this.cognitoService.handleResetPassword(email);
          this.loader = false;
          this.isresetpassword = false;
          this.isSignUpComplete = true;
          this.signInErrorMessage = '';
          this.showCreateAccountLink = false;
          this.logUserEvent(email, 'forgot password', 'pass', '', 1);
        } catch (error) {
          this.loader = false;
          console.error('Error during password reset:', error);
          this.showCreateAccountLink = false;
          this.showError('Error during password reset. Please try again.');
        }
      },
      (err) => {
        this.loader = false;
        console.error('Error during check email exists API:', err);
        this.showCreateAccountLink = false;
        this.showError('Error occurred while checking email');
      }
    );
  }

  async onSendResetCodeB2B() {
    this.confirmationCode = '';
    this.newPassword = '';

    const mobileTrimmed = this.mobile?.trim();
    if (!mobileTrimmed) {
      this.showError('Mobile number is required to reset password');
      return;
    }

    if (!/^[0-9]{10}$/.test(mobileTrimmed)) {
      this.showError('Please enter a valid 10-digit mobile number');
      return;
    }

    this.loader = true;
    const formattedMobile = mobileTrimmed.startsWith('+91') ? mobileTrimmed : `+91${mobileTrimmed}`;
    this.cognitoService.b2bcheckMobile_exits({ mobile: formattedMobile }).subscribe(
      (response: any) => {
        const body = typeof response.body === 'string' ? JSON.parse(response.body) : response.body;
        if (!body?.exists) {
          this.showError('No account found with this mobile number. Please verify.');
          this.loader = false;
          return;
        }
        const otpRequest = { mobile: mobileTrimmed };
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(otpRequest), HASHKEY).toString();
        this.cognitoService.sendOtp({ mobile: ciphertext }).subscribe(
          (otpResponse: any) => {
            const resBody = typeof otpResponse.body === 'string' ? JSON.parse(otpResponse.body) : otpResponse.body;
            if (resBody?.success) {
              this.isresetpasswordb2b = false;
              this.isconfirmpasswordb2b = true;
              this.showError('');
            } else {
              this.showError('Too many attempts. Try again after 1 hour.');
              this.isconfirmpasswordb2b = false;
            }
            this.loader = false;
          }
        );
        this.logUserEvent(mobileTrimmed, 'forgot password', 'pass', '', 2);
      },
      (error) => {
        this.showError('Error occurred while checking mobile number');
        this.loader = false;
      }
    );
  }



  async onConfirmPasswordReset() {
    const code = this.confirmationCode?.trim();
    const newPassword = this.newPassword?.trim();

    if (!code) {
      return this.showError('Confirmation code is required to confirm password reset.', 5000);
    }
    if (!newPassword) {
      return this.showError('Password is required.', 5000);
    }

    this.loader = true;

    try {
      // Step 1: Confirm password reset using Cognito
      await this.cognitoService.handleConfirmResetPassword({
        username: this.email,
        confirmationCode: code,
        newPassword: newPassword,
      });

      // Step 2: Update user status in backend (keep encryption)
      const userUpdate = { email: this.email, user_status: '1' };
      const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(userUpdate), HASHKEY).toString();
      this.cognitoService.UserUpdate({ data: ciphertext }).subscribe({
        next: () => { },
        error: (err) => console.error('Error during B2C user status update:', err),
      });

      // Step 3: Reset UI state
      this.loader = false;
      this.passwordResetSuccess = true;
      this.otpexpiredpop = false;
      this.isPasswordReset = false;
      this.isSignUpComplete = false;
      this.isSignIn = false;
      this.username = '';
      this.password = '';

      await this.logUserEvent(this.email, 'password reset', 'pass', '', 1);
    } catch (error: any) {
      this.loader = false;
      const errMsg = error?.message;

      if (error?.name === 'LimitExceededException') {
        this.showError(errMsg);
        await this.logUserEvent(this.email, 'password attempt', 'fail', 'Attempt limit exceeded', 1);
      } else if (error?.name === 'InvalidPasswordException' && errMsg.includes('Password does not conform to policy')) {
        this.showError('Password must be at least 8 characters long and include at least one uppercase letter and one special character.');
        await this.logUserEvent(this.email, 'change password', 'fail', 'Password policy issue', 1);
      } else {
        this.showError(errMsg);
        await this.logUserEvent(this.email, 'change password', 'fail', 'Invalid code', 1);
      }
    }
  }


  async onConfirmPasswordResetB2B() {
    const confirmationCode = this.confirmationCode?.trim();
    const newPassword = this.newPassword?.trim();
    const formattedMobile = this.mobile.trim().startsWith('+91') ? this.mobile.trim() : `+91${this.mobile.trim()}`;

    if (!confirmationCode) return this.showError('Confirmation code is required to confirm password reset.');
    if (!newPassword) return this.showError('Password is required.');

    const verifyOtpBody = { user_id: this.mobile, otp: confirmationCode };
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(verifyOtpBody), HASHKEY).toString();
    this.loader = true;

    this.cognitoService.newverifyOtp({ data: ciphertext }).subscribe(
      (otpRes: any) => {
        const otpBody = typeof otpRes.body === 'string' ? JSON.parse(otpRes.body) : otpRes.body;

        if (!otpBody?.success) {
          this.loader = false;
          return this.showError('Invalid confirmation code. Please try again.');
        }
        const token = otpBody?.token;
        const resetPasswordBody = { username: formattedMobile, password: newPassword, token: token };
        this.cognitoService.b2bPasswordReset(resetPasswordBody).subscribe(
          (passRes: any) => {
            const passBody = typeof passRes.body === 'string' ? JSON.parse(passRes.body) : passRes.body;

            if (!passBody?.success) {
              const code = passBody?.message?.code;
              const msg = passBody?.message?.message || 'Password reset failed.';
              this.loader = false;

              if (code === 'InvalidPasswordException') {
                return this.showError('Password must be at least 8 characters long and include at least one uppercase letter and one special character.');
              }
              return this.showError(msg);
            }
            const userUpdate = { mobile: formattedMobile, user_status: '1' };
            this.cognitoService.b2b_user_status_update(userUpdate).subscribe(
              () => { },
              (err) => console.error('Error during user status update:', err)
            );

            this.passwordResetSuccess = true;
            this.otpexpiredpop = false;
            this.isPasswordReset = false;
            this.isconfirmpasswordb2b = false;
            this.isSignIn = false;
            this.username = '';
            this.password = '';
            this.loader = false;

            this.logUserEvent(this.mobile, 'password reset', 'pass', '', 2);
          },
          () => {
            this.loader = false;
            this.showError('Error occurred during password reset.');
          }
        );
      },
      () => {
        this.loader = false;
        this.showError('Error occurred during OTP verification.');
      }
    );
  }


  continueAsCurrentUser() {
    if (this.clientId === environment.b2b_insurance || this.clientId === environment.retirment_clientid || this.clientId === environment.surveypro_clientid || this.clientId === environment.bqdashboard_clientid || this.clientId === environment.post_retirement_clientid || this.clientId === environment.b2b_india_bonds_clientid || this.clientId === environment.DatacloudWM_clientid || this.clientId === environment.fpb2b_clientid || this.clientId === environment.digitalrm_clientid) {
      if (!localStorage.getItem('ssobauthToekn')) {
        this.UserSignIn = false;
      } else {
        this.redirectUser('b2b');
      }
    } else {
      if (!localStorage.getItem('ssocauthToekn')) {
        this.UserSignIn = false;
      } else {
        this.redirectUser('b2c');
      }
    }
  }




  async onGoogleSignIn() {
    try {
      await this.cognitoService.signOut();
      await this.cognitoService.handleGoogleSignIn(true);
    } catch (error) {
      console.error('Google Sign-In error:', error);
    }
  }
  async handleSignOut() {
    try {
      this.loader = true;
      // Check if clientId belongs to B2B or B2C
      const isB2B = [environment.b2b_insurance, environment.retirment_clientid, environment.surveypro_clientid, environment.bqdashboard_clientid, environment.post_retirement_clientid, environment.b2b_india_bonds_clientid, environment.DatacloudWM_clientid, environment.fpb2b_clientid,environment.digitalrm_clientid].includes(this.clientId);
      if (isB2B) {
        await this.cognitoService.signOut();
        localStorage.removeItem('ssobauthToekn');
        this.UserSignIn = false;
      } else {
        await this.cognitoService.signOut();
        localStorage.removeItem('ssocauthToekn');
        this.UserSignIn = false;
      }
      setTimeout(() => {
        this.loader = false;
      }, 2000);
    } catch (error) {
      console.error('Handle Sign-Out error:', error);
      this.loader = false;
    }
  }





  forsignup() {
    this.router.navigate(['/sign-up'], {
      queryParams: { clientId: this.clientId },
    });
  }


  signinotp() {
    this.showError('');
    const mobileNumberRegex = /^[0-9]{10}$/;
    if (mobileNumberRegex.test(this.username)) {
      this.mobile = this.username;
    }
    else if (mobileNumberRegex.test(this.username2)) {
      this.mobile = this.username2;
    }
    else {
      this.mobile = '';
    }
    this.isSignIn = false;
    this.isresetpassword = false;
    this.isSignUpComplete = false;
    this.signmobile = true;
  }

  isB2BClient(): boolean {
    return [
      this.b2b_insurance,
      this.retirment_clientid,
      this.surveypro_clientid,
      this.bqdashboard_clientid,
      this.post_retirement_clientid,
      this.b2b_india_bonds_clientid, this.DatacloudWM_clientid, this.fpb2b_clientid,this.digitalrm_clientid
    ].includes(this.clientId);
  }

  async initiateOTPSignIn() {
    this.resendotp = false;
    this.otp = '';

    if (!this.mobile || this.mobile.trim() === '') {
      return this.showError('Mobile number is required.');
    }

    const mobileWithCountryCode = '+91' + this.mobile.trim();
    const numberLength = this.mobile.trim().length;

    if (numberLength !== 10) {
      return this.showError('Please enter a valid 10-digit mobile number.');
    }
    this.loader = true;
    try {
      // Check for inactive users ONLY for specific clientIds
      if (this.isB2BClient()) {
        const userObj = { mobile: '+91' + this.mobile };
        const userResponse: any = await this.cognitoService.useractive(userObj).toPromise();
        const parsedBody = JSON.parse(userResponse.body);
        // Check for "User does not exist" message
        if (parsedBody && parsedBody.e_type === '3') {
          this.loader = false;
          return this.showError('User does not exist. Please contact your administrator.');
        }
        // Handle inactive user
        if (parsedBody && parsedBody.success && parsedBody.e_type === '2') {
          this.loader = false;
          this.isUserInactive = true;
          return;
        }
      }
      // Proceed with OTP sign-in for all clientIds
      const nextStep = await this.cognitoService.handleSignInOTP({
        username: mobileWithCountryCode,
      });
      await this.logUserEvent(mobileWithCountryCode, 'otp sent for signIn', 'pass', '', this.isB2BClient() ? 2 : 1);
      setTimeout(() => {
        this.signmobile = false;
        this.loader = false;
        this.signotp = true;
      }, 1000);
    }
    catch (error: any) {
      this.loader = false;

      if (error.name === 'InvalidLambdaResponseException') {
        const msg = this.isB2BClient() ? 'User does not exist.Please contact your administrator.' : 'User does not exist. Please sign up first.';
        this.showError(msg);
      }
      else if (error.name === 'UserLambdaValidationException' && error.message.includes('Error sending OTP')) {
        this.showError('Something went wrong. Please try again later.');
      }
      else if (error.message.includes('There is already a signed in user')) {
        this.showError('There is already a signed-in user');
        location.reload();
        this.showError('');
      }
      else if (error.name === 'UserLambdaValidationException' && error.message.includes('CreateAuthChallenge failed with error OTP limit exceeded')) {
        this.showError('Too many attempts. Try again after 1 hour.');
      }
      else {
        this.showError('Something went wrong. Please try again.');
      }
      console.error('Error during sign-in:');
    }
  }


  async verifyOTP() {
    const mobileWithCountryCode = '+91' + this.mobile;

    const isB2BClient = [this.b2b_insurance, this.retirment_clientid, this.surveypro_clientid, this.bqdashboard_clientid, this.post_retirement_clientid, this.b2b_india_bonds_clientid, this.DatacloudWM_clientid, this.fpb2b_clientid,this.digitalrm_clientid].includes(this.clientId);

    const appType = isB2BClient ? 2 : 1;
    try {
      this.loader = true;
      const nextStep = await this.cognitoService.verifyOTP(this.otp);
      if (nextStep.signInStep == 'DONE') {
        await this.logUserEvent(mobileWithCountryCode, 'otp verify for signIn', 'pass', '', appType);
        await this.logUserEvent(mobileWithCountryCode, 'signIn', 'pass', '', appType);

        const type = isB2BClient ? 'b2b' : 'b2c';
        this.redirectUser(type);
      }
      else if (nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
        await this.logUserEvent(mobileWithCountryCode, 'otp check for signIn', 'fail', 'invalid otp', appType);
        this.showError('Please enter a valid OTP');
      }
    }
    catch (error: any) {
      if (error.message.includes('challengeResponse is required to confirmSignIn')) {
        this.showError('Please enter an OTP');
      }
      if (error.name === 'InvalidLambdaResponseException' || error.name === 'NotAuthorizedException') {
        const mobileWithCountryCode = '+91' + this.mobile;
        await this.logUserEvent(mobileWithCountryCode, 'resend otp', 'pass', '', appType);
        this.showError('Please resend OTP');
        this.resendotp = true;
      }
      console.error('Error verifying OTP:');
    }
  }

  showsignin() {
    this.signmobile = false;
    this.isSignIn = true;
  }

  showsignin2() {
    this.signmobile = false;
    this.signotp = false;
    this.isSignIn = true;
  }

  async editMobile() {
    const mobileWithCountryCode = '+91' + this.mobile;
    const isB2BClient = [this.b2b_insurance, this.retirment_clientid, this.surveypro_clientid, this.bqdashboard_clientid, this.post_retirement_clientid, this.b2b_india_bonds_clientid, this.DatacloudWM_clientid, this.fpb2b_clientid,this.digitalrm_clientid].includes(this.clientId);
    const appType = isB2BClient ? 2 : 1;
    this.loader = false;
    this.showError('');
    this.signotp = false;
    this.signmobile = true;
    await this.logUserEvent(mobileWithCountryCode, 'click on edit mobile', 'pass', '', appType);
  }

  validateUsername() {
    const isMobile = /^[0-9]{10}$/.test(this.username);
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.username);

    let signInUsername = this.username.trim();
    if (isMobile) {
      signInUsername = '+91' + this.username;
    } else if (!isMobile && /^[0-9]+$/.test(this.username)) {
      this.showError('Mobile number must be exactly 10 digits');
      return;
    } else if (!isEmail) {
      this.showError('Please enter a valid email');
      return;
    } else {
      // console.log('Valid email input:', signInUsername);
    }
  }

  validateUsername2() {
    if (!this.username2) {
      this.showError('Please enter a valid Mobile/Email/RMCode');
      return false;
    }

    let signInUsername = this.username2.trim();
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(signInUsername);
    const numbersOnly = /^[0-9]+$/.test(signInUsername);
    const isRmCode = /^[0-9]{5,6}$/.test(signInUsername);
    const isMobile = /^[0-9]{10}$/.test(signInUsername);

    if (numbersOnly && signInUsername.length <= 6) {
      if (!isRmCode) {
        this.showError('Please enter a valid RM Code');
        return false;
      }
    } else if (isRmCode) {
      return true;
    } else if (numbersOnly && signInUsername.length !== 10) {
      this.showError('Mobile number must be exactly 10 digits');
      return false;
    } else if (numbersOnly && !this.isMobileWrong(signInUsername)) {
      this.showError('Please enter a valid mobile number');
      return false;
    } else if (isMobile) {
      return true;
    } else if (!isEmail) {
      this.showError('Please enter a valid email', 4000);
      return false;
    }

    return true;
  }

  isMobileWrong(test: any) {
    let firstDigit = test.substr(0, 1);
    if (
      firstDigit != '6' &&
      firstDigit != '7' &&
      firstDigit != '8' &&
      firstDigit != '9'
    ) {
      return 0;
    } else if (test.match(/^(\d)\1+$/g)) {
      return false;
    } else {
      return true;
    }
  }

  validatePassword() {
    if (!this.password) {
      this.showError('Password is required to sign in');
    }
  }

  validatePassword2() {
    if (!this.password2) {
      this.showError('Password is required to sign in');
    }
  }

  validateEmailAddress() {
    if (this.username) {
      const lastChars = this.username.lastIndexOf('.');
      const expression =
        /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

      if (
        !expression.test(String(this.username).toLowerCase()) ||
        this.username.substr(lastChars, 3).length < 3
      ) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  ResetSucess() {
    this.passwordResetSuccess = false;
    this.isSignIn = true;
    this.username = '';
    this.password = '';
  }

  loginwithpassword() {
    this.showError('');
    this.signmobile = false;
    this.isSignIn = true;
  }

  async logUserEvent(
    userid: string,
    event_type: string,
    event_result: string,
    event_error: string,
    AppType: number
  ) {
    let jscd: any = window[<any>'jscd'];

    // const ipResponse = await this.cognitoService.getIpAddress().catch((err) => {
    //   console.error('Failed to fetch IP address:', err);
    //   return null;
    // });

    const userevntobj = {
      userid,
      event_type,
      event_result,
      event_error,
      AppType,
      client_id: this.clientId,
      // ip_address: ipResponse || 'Unknown',
      ip_address:'Unknown',
      device: `${jscd?.browser} ${jscd?.os} ${jscd?.osVersion}`,
    };
    this.cognitoService.UserEventHistory(userevntobj).subscribe();
  }

  handleInactiveUser() {
    this.router.navigate(['/sign-in'], {
      queryParams: { clientId: this.clientId },
    });
    this.isUserInactive = false;
  }

}
